import React from "react";
import Checkbox from "@mui/material/Checkbox";
import PropTypes from "prop-types";
import "./CheckBox.css";

function CheckBox({
  id,
  disabled,
  labelText,
  defaultChecked,
  boxClassName,
  labelClassName,
  checked,
  onChange,
  ...restProps
}) {
  const checkboxProps =
    checked !== undefined
      ? { checked }
      : { defaultChecked };

  return (
    <div className="checkbox-container">
      <Checkbox
        id={id}
        disabled={disabled}
        className={`boxClass ${boxClassName}`}
        onChange={onChange}
        {...checkboxProps}
        {...restProps}
      />
      {labelText && <label className={labelClassName}>{labelText}</label>}
    </div>
  );
}
CheckBox.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.string,
  disabled: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  boxClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

CheckBox.defaultProps = {
  id: "",
  labelText: "",
  disabled: false,
  defaultChecked: false,
  boxClassName: "boxClass",
  labelClassName: "boxLabel",
  onChange: () => {},
};

export default CheckBox;
